import { ensureDemoUiStyles } from '../demo/DemoExitButton'
import demoSession from '../demo/DemoSession'
import { bindNaoMostrarNovamente } from '../primeiroLogin'

const bindWelcomeActions = (tourManager) => {
    ensureDemoUiStyles()

    setTimeout(() => {
        document.querySelector('.driver-popover')?.classList.add('hdv-tour-boas-vindas')

        const startDemo = document.querySelector('[data-hdv-welcome-demo]')
        const cancelWelcome = document.querySelector('[data-hdv-welcome-cancel]')

        if (startDemo && !startDemo._hdvBound) {
            startDemo._hdvBound = true
            startDemo.addEventListener('click', (event) => {
                event.preventDefault()
                event.stopPropagation()
                tourManager.finish('boas-vindas')
                demoSession.start({ startTour: 'demo-equipamento', resumeIndex: 0 })
            })
        }

        if (cancelWelcome && !cancelWelcome._hdvBound) {
            cancelWelcome._hdvBound = true
            cancelWelcome.addEventListener('click', (event) => {
                event.preventDefault()
                event.stopPropagation()
                tourManager.finish('boas-vindas')
            })
        }

        bindNaoMostrarNovamente()
    }, 0)
}

const buildBoasVindasTourSteps = (tourManager) => [
    {
        onHighlighted: () => bindWelcomeActions(tourManager),
        popover: {
            title: 'Bem-vindo!',
            description:
                'Para começar, você precisa cadastrar o <strong>Equipamento</strong>, o <strong>Cliente</strong> e o <strong>Monitorado</strong> que serão utilizados na telemetria.<br><br>' +
                'Para mostrar como esse processo funciona, disponibilizamos um tour demonstrativo com dados de exemplo. Você poderá acompanhar os cadastros passo a passo e ver como os dados do monitorado são apresentados nos <strong>gráficos e supervisórios</strong>.<br><br>' +
                'Os dados utilizados na demonstração são fictícios e não alteram seus dados reais.' +
                '<div class="hdv-tour-choice-actions">' +
                '<button type="button" class="hdv-tour-choice-demo" data-hdv-welcome-demo>Iniciar tour demonstrativo</button>' +
                '<button type="button" class="hdv-tour-choice-cancel" data-hdv-welcome-cancel>Cancelar</button>' +
                '</div>' +
                '<label class="hdv-tour-nao-mostrar">' +
                '<input type="checkbox" data-hdv-nao-mostrar-novamente />' +
                'Não mostrar novamente' +
                '</label>',
            side: 'over',
            align: 'center',
            showButtons: ['close'],
            popoverClass: 'hdv-tour-popover hdv-tour-boas-vindas',
        },
    },
]

export default buildBoasVindasTourSteps
